module.exports = __webpack_public_path__ + "img/guangai.cea9def4.png";